import { render, staticRenderFns } from "./PayslipHourlyPolicyRules.vue?vue&type=template&id=8ac959dc&"
import script from "./PayslipHourlyPolicyRules.vue?vue&type=script&lang=js&"
export * from "./PayslipHourlyPolicyRules.vue?vue&type=script&lang=js&"
import style0 from "./PayslipHourlyPolicyRules.vue?vue&type=style&index=0&id=8ac959dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports